//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {

    angular
        .module('app')
        .directive('uploadFile', uploadFile);

    function uploadFile() {
        return {
            templateUrl: 'components/directives/upload_file/view.upload_file.html',
            restrict: 'E',
            controller: 'UploadFileController',
            controllerAs: 'vm',
            scope: {
                'name': "<",
                'file': '=',
                'change': '=',
                'base64': '='
            },
            bindToController: true
        };
    }

})();
